import React, { useCallback } from 'react';
import { useTranslation } from 'localization';

export interface UseCaseFilterMoleculeProps {
  useCases: string[];
  selectedUseCase: string | null;
  onSelect: (useCase: string | null) => void;
  className?: string;
}

const UseCaseFilterMolecule: React.FC<UseCaseFilterMoleculeProps> = ({
  useCases,
  selectedUseCase,
  onSelect,
  className = '',
}) => {
  const { t } = useTranslation();

  const handleSelect = useCallback(
    (useCase: string | null) => {
      onSelect(useCase);
    },
    [onSelect],
  );

  const formatLabel = (tag: string): string => {
    return tag
      .split(/[-_]/)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const classes = ['marketplace-usecase-filter', className]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes} role="tablist" aria-label={t('marketplace.useCases.title')}>
      <div className="marketplace-usecase-filter__scroll">
        {useCases.map((useCase) => (
          <button
            key={useCase}
            type="button"
            role="tab"
            aria-selected={selectedUseCase === useCase}
            className={[
              'marketplace-usecase-filter__pill',
              selectedUseCase === useCase
                ? 'marketplace-usecase-filter__pill--active'
                : '',
            ]
              .filter(Boolean)
              .join(' ')}
            onClick={() => handleSelect(useCase)}
          >
            <i
              className="pi pi-tag marketplace-usecase-filter__pill-icon"
              aria-hidden="true"
            />
            <span className="marketplace-usecase-filter__pill-label">
              {formatLabel(useCase)}
            </span>
          </button>
        ))}
        {selectedUseCase !== null && (
          <button
            type="button"
            className="marketplace-usecase-filter__pill marketplace-usecase-filter__pill--clear"
            onClick={() => handleSelect(null)}
          >
            <i
              className="pi pi-times marketplace-usecase-filter__pill-icon"
              aria-hidden="true"
            />
            <span className="marketplace-usecase-filter__pill-label">
              {t('marketplace.useCases.clear')}
            </span>
          </button>
        )}
      </div>
    </div>
  );
};

export default UseCaseFilterMolecule;
